module.exports = __webpack_public_path__ + "img/icon4.422a2714.gif";